import {
  Login as LoginIcon,
  ExitToApp as ExitToAppIcon,
  LocalParking as LocalParkingIcon,
  MeetingRoom as MeetingRoomIcon,
} from "@mui/icons-material";
import { ApiEntryPoint } from "@/types/common";

const DEFAULT_FONT_SIZE = { xs: "4.5vw", sm: 20 };

export const getIconForSectionType = (
  type: string,
  fontSize: string | object = DEFAULT_FONT_SIZE,
) => {
  const sx = { color: "#8D28E6", fontSize };
  if (type.includes("Main")) return <LoginIcon sx={sx} />;
  if (type.includes("Back")) return <ExitToAppIcon sx={{ ...sx, transform: "scaleX(-1)" }} />;
  if (type.includes("Parking")) return <LocalParkingIcon sx={sx} />;
  return <MeetingRoomIcon sx={sx} />;
};

export const getEntryPointIcon = (ep: ApiEntryPoint) => {
  const sectionType = ep.buildingSection?.section_type ?? ep.entry_name;
  return getIconForSectionType(sectionType);
};
